<template>
  <div class="profile-layout">
    <Navbar />
    <main class="content">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ProfileLayout",
  components: { Footer, Navbar },
};
</script>

<style scoped>
.profile-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1;
}

@media (max-width: 640px) {
  .content {
    margin-top: 90px;
  }
}
</style>
